var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',{staticClass:"selected-group-tag-box d-flex gap-2 pt-3"},[_c('div',{staticClass:"col-2"}),_c('GroupTagVirtualList',{attrs:{"items":_vm.items,"class-name":"w--70"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }